<template>
  <BaseModal
    :model-value="modelValue"
    class="gap-0 !rounded-2xl w-[420px] min-h-[700px] px-4 flex flex-col justify-between"
    @update:model-value="updateModelValue"
  >
    <!-- Content (with higher z-index) -->
    <div class="z-10 w-full text-lavender flex flex-col">
      <div class="relative w-[336px]">
        <h1
          class="text-light1 font-medium text-[45px] leading-10 tracking-[-2.25px]"
        >
          {{ $t('buyOrStakeLingo.title') }}
        </h1>
        <h1
          class="text-light1 font-medium flare text-[45px] leading-10 tracking-[-2.25px]"
        >
          {{ $t('buyOrStakeLingo.title') }}
        </h1>
      </div>
      <div class="mt-4 flex flex-col gap-1">
        <span
          class="text-xl text-justify md:text-[20px] leading-5 md:leading-6 tracking-[-0.8px] whitespace-pre-line"
          v-html="$t('buyOrStakeLingo.description', { entries })"
        />
      </div>
    </div>

    <template
      #footer
    >
      <div class="w-full flex items-center justify-center">
        <GlowButton
          :color="EButtonColor.BLUE"
          class="w-full"
          @click="goToStake"
        >
          <span> {{ $t('buyOrStakeLingo.stake') }} </span>
        </GlowButton>
      </div>
    </template>
    <img
      :src="successBg"
      alt="Success"
      class="w-full h-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
    >
  </BaseModal>
</template>

<script setup lang="ts">
import successBg from '@/assets/images/upsell-success-bg.png'
import BaseModal from '@/components/ui/dialog/BaseModal.vue'
import { EButtonColor } from '@/types/shared/button'
import GlowButton from '@/components/ui/button/GlowButton.vue'
import mixpanel from 'mixpanel-browser'
import { LingoRouteName } from '@/router/routes'
import { computed, watch } from 'vue'
import { useLingoPrice } from '@/composables/contracts/lingo-price'
import { useConfig } from '@/composables/config'
import { LOCK_DURATION_ID } from '@/types/staking'
import { useRouter } from 'vue-router'

const props = defineProps<{
  modelValue: boolean
}>()

const { price } = useLingoPrice()
const { lockConfig } = useConfig()
const router = useRouter()
const SMASH_POWER_MILES_COST = 100

const entries = computed(() => {
  if (!price.value || !lockConfig.value?.power?.base) return 0
  const usdAmount = 10
  const coins = usdAmount / price.value
  const { base, decimalCount } = lockConfig.value.power
  const lockData = lockConfig.value.lockDurations[LOCK_DURATION_ID.TWELVE_MONTHS]
  const boost = 1 + (lockData?.boost ?? 0)
  const hourlyPower = Math.round(base * boost * coins) / Math.pow(10, decimalCount)
  const dailyPower = hourlyPower * 24
  const totalPowerMiles = dailyPower * 365
  return Math.floor(totalPowerMiles / SMASH_POWER_MILES_COST)
})

watch(() => props.modelValue, (val) => {
  if (val) {
    mixpanel.track('Get Started Popup View')
  }
})

function goToStake() {
  mixpanel.track('New User Popup Stake LINGO Button Clicked', {
    entryPoint: 'getStartedPopup',
  })
  mixpanel.track('Staking Started', {
    entryPoint: 'getStartedPopup',
  })
  emit('update:modelValue', false)
  router.replace({ name: LingoRouteName.STAKING_NEW })
}

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const updateModelValue = (val: boolean) => {
  emit('update:modelValue', val)
}
</script>
<style>
.flare {
  width: 100%;
  position: absolute;
  filter: blur(4px);
  overflow: hidden;
  top: 0px;
  left: 0px;
  background: radial-gradient(104.64% 67.93% at 115.38% 32.81%, #F1E6FA 0%, rgba(241, 230, 250, 0.00) 100%);
  background-clip: text;
  color: transparent;
  transition: all 0.3s;
  mix-blend-mode: plus-lighter;
  pointer-events: none;
}
</style>
